<div class="liberro-box-consultant" [class.liberro-box-consultant--white]="whiteVariant">
  @if (loadingInfo) {
    <liberro-spinner [show]="true" type="inline"></liberro-spinner>
  } @else if (clientNotLinkedToCollaborator) {
    <div class="no-collaborator-section" [class.no-collaborator-section--white]="whiteVariant">
      <div class="no-collaborator-icon-card">
        <svg-icon
          src="assets/icons/user-plus.svg"
          class="no-collaborator-icon"
        ></svg-icon>
      </div>
      <div class="no-collaborator-content">
        <div class="no-collaborator-title">
          {{ 'collaborator.noCollaboratorTitle' | translate }}
        </div>
        <div class="no-collaborator-description">
          {{ 'collaborator.noCollaboratorContactInfo' | translate }}
        </div>
      </div>
    </div>
  } @else {
    <div class="liberro-box-content-wrapper" [class.liberro-box-content-wrapper--white]="whiteVariant">
      <div>
        <div class="heading" [class.white-content-pad]="whiteVariant">{{ heading ?? ('faq.box-consultant.heading' | translate) }}</div>
        <div class="description" [class.white-content-pad]="whiteVariant">
          @if (description) {
            <span>{{ description }}</span>
          } @else {
            <span>{{ 'faq.box-consultant.helpDescription1' | translate}}</span>
            <span>{{ 'faq.box-consultant.helpDescription2' | translate}}</span>
          }
        </div>
        <liberro-button (click)="onBtnConsultation()" customWidth="306px" [widthType]="wantConsulationWidthType" [label]="ctaLabel ?? ('faq.box-consultant.label' | translate)" [danger]="true"></liberro-button>
      </div>
      <div>
        <div class="consultant-header">
          <div>
            <liberro-avatar-photo [photoUrl]="photoUrl" fallbackType="user" size="64"></liberro-avatar-photo>
          </div>
          <div class="consultant-name">
            {{ name ? name :  ('faq.box-consultant.noName' | translate) }}
          </div>
        </div>
        <nz-divider></nz-divider>
        <div class="consultant-contacts">
          <liberro-contact-detail
            icon="assets/icons/mail.svg"
            [label]="'faq.box-consultant.email' | translate"
            [value]="email"
            type="email">
          </liberro-contact-detail>
          <liberro-contact-detail
            icon="assets/icons/phone.svg"
            [label]="'faq.box-consultant.phone' | translate"
            [value]="phone"
            type="phone">
          </liberro-contact-detail>
        </div>
      </div>
    </div>
  }
</div>
